import { guides } from '@/mocks/chigua';
import { SectionHead } from './HotDeep';

export function Guide() {
  return (
    <section id="guide" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <SectionHead
        eyebrow="Field Guide"
        title="进阶吃瓜五步法"
        desc="想把瓜吃得比路人更深？照着这套流程，从素材到手一步步建立自己的证据意识。"
      />
      <div className="mt-10 grid gap-4 md:grid-cols-5 sm:grid-cols-2">
        {guides.map((g, i) => (
          <article
            key={g.step}
            className="group relative overflow-hidden rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
          >
            <span className="absolute -right-2 -top-5 font-heading text-7xl font-black text-background-200 transition-colors group-hover:text-primary-100">
              {g.step}
            </span>
            <div className="relative">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-sm font-black text-background-50">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{g.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}